<template>
  <div class="fiche-entreprise">
    <va-modal
      class="modal"
      v-model="showSalarie"
      cancelText="Annuler"
      okText="Enregistrer"
      max-width="100%"
      v-on:ok="createSalarie"
      v-on:cancel="closeModal"
      hideDefaultActions
      noEscDismiss
      noOutsideDismiss
      disabled
    >
      <div class="specialwidth">
        <div class="row row-inside">
          <div class="flex md4">

            <span style="color: blue"><b>Ajout collaborateur</b> </span>
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md4 padded-input">
            <va-select
              label="Titre"
              v-model="titre"
              :options="titreOptions"
              no-clear
            />
          </div>

          <div class="flex md4 padded-input">
            <va-input
              v-model="nom"
              placeholder="-"
              label="Nom"
            />
          </div>
          <div class="flex md4 padded-input">
            <va-input
              v-model="prenom"
              placeholder="-"
              label="Prénom"
            />
          </div>
        </div>
        <div class="row row-inside">
          <div class="flex md4 padded-input">
            <editable-date-picker
              label="Date de naissance"
              :config="{ dateFormat: 'd-m-Y' }"
              v-model="birthdate"
              @input-raw="birthdateRawInput = $event"
            />
          </div>
          <div class="flex md4 padded-input">
            <va-input
              v-model="telephone"
              placeholder="-"
              label="Téléphone"
            />
          </div>
          <div class="flex md4 padded-input">
            <va-input
              v-model="email"
              placeholder="-"
              label="Courriel"
            />
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md4 padded-input">
            <va-select
              label="Poste dans l'entreprise"
              v-model="poste"
              key-by="idformation_emploi_poste"
              text-by="nom"
              :options="posteOptions"
              no-clear
            />
          </div>
          <div class="flex md4 padded-input">
            <va-select
              label="Contrat de travail"
              v-model="contrat"
              :options="contratOption"
              key-by="idformation_emploi_contrat"
              text-by="nom"
              no-clear
            />
          </div>
          <div class="flex md4 padded-input">
            <va-select
              label="Statut"
              v-model="statut"
              key-by="idformation_emploi_status"
              text-by="nom"
              :options="statutOption"
              no-clear
            />
          </div>
        </div>
        <div class="row row-inside">
          <div class="flex md7 padded-input">
            <va-select
              label="Selection de l'entreprise"
              key-by="identreprise"
              text-by="nom"
              :options="listeEntreprise"
              placeholder="Selection de l'entreprise"
              v-model="entrepriseSelect"
              searchable
            />
          </div>
          <div class="flex md5 padded-input">
            <editable-date-picker
              label="Date de début de contrat"
              :config="{ dateFormat: 'd-m-Y' }"
              v-model="start_contract"
              @input-raw="startContractRawInput = $event"
            />
          </div>
        </div>
      </div>
      <template v-slot:actions>
        <div class="va-modal__actions mb-3">
          <va-button color="gray" flat @click="closeModal">Annuler</va-button>
          <va-button @click="createSalarie">Enregistrer</va-button>
        </div>
      </template>
    </va-modal>
  </div>
</template>
  
  <script>
import axios from "axios";
import moment from "moment";
import EditableDatePicker from "./EditableDatePicker.vue";

export default {
  name: "fiche-entreprise",
  components: {
    "editable-date-picker": EditableDatePicker,
  },
  props: ["value", "identreprise"],
  data() {
    return {
      isready: false,
      showSalarie: false,
      titre: "",
      nom: "",
      prenom: "",
      email: "",
      telephone: "",
      birthdate: "",
      birthdateRawInput: "",
      start_contract: moment().format("DD-MM-YYYY"),
      startContractRawInput: moment().format("DD-MM-YYYY"),
      poste: "",
      contrat: "",
      statut: "",
      contratOption: [
        { idformation_emploi_contrat: 1, nom: "CDI" },
        { idformation_emploi_contrat: 2, nom: "CDD" },
        { idformation_emploi_contrat: 3, nom: "Intérim" },
		{ idformation_emploi_contrat: 4, nom: "" },
      ],
      statutOption: [
        { idformation_emploi_status: 1, nom: "Dirigeant-ti" },
        { idformation_emploi_status: 2, nom: "Salarié" },
		{ idformation_emploi_status: 3, nom: "Dirigeant salarié" },
      ],
      titreOptions: ["MONSIEUR", "MADAME"],
      posteOptions: [
        { idformation_emploi_poste: 1, nom: "Directeur" },
        { idformation_emploi_poste: 2, nom: "Employé de marée" },
        { idformation_emploi_poste: 3, nom: "Collaborateur" },
      ],
      listeEntreprise: [],
      entrepriseSelect: "",

    };
  },
  methods: {
    openSalarie() {
      console.log("openSalarie");
    },
    async createSalarie() {
      console.log("saveSalarie");
      const titre = (this.titre || "").toString().trim();
      const nom = (this.nom || "").toString().trim();
      const prenom = (this.prenom || "").toString().trim();
      const birthdateRaw = (this.birthdateRawInput || "").toString().trim();
      const startContractRaw = (this.startContractRawInput || "").toString().trim();

      if (!titre) {
        this.launchToast("Le titre est obligatoire");
        return;
      } else if (!nom) {
        this.launchToast("Le nom est obligatoire");
        return;
      } else if (!prenom) {
        this.launchToast("Le prénom est obligatoire");
        return;
      } else if (!this.statut || !this.statut.idformation_emploi_status) {
        this.launchToast("Le statut est obligatoire");
        return;
      } else if (!this.contrat || !this.contrat.idformation_emploi_contrat) {
        this.launchToast("Le contrat de travail est obligatoire");
        return;
      } else if (!startContractRaw) {
        this.launchToast("La date de début de contrat est obligatoire");
        return;
      } else if (!this.poste || !this.poste.idformation_emploi_poste) {
        this.launchToast("Le poste est obligatoire");
        return;
      }

      let birthdateParsed = null;
      if (birthdateRaw) {
        birthdateParsed = moment(birthdateRaw, ["DD-MM-YYYY", "DD/MM/YYYY"], true);
        if (!birthdateParsed.isValid()) {
          this.launchToast("La date de naissance doit être au format JJ-MM-AAAA ou JJ/MM/AAAA");
          return;
        }
      }

      const startContractParsed = moment(startContractRaw, ["DD-MM-YYYY", "DD/MM/YYYY"], true);
      if (!startContractParsed.isValid()) {
        this.launchToast("La date de début de contrat doit être au format JJ-MM-AAAA ou JJ/MM/AAAA");
        return;
      }

      let infos = {}
      infos.salarie = {
        titre: titre,
        nom: nom,
        prenom: prenom,
        email: this.email,
        telephone: this.telephone,
        birthdate: birthdateParsed ? birthdateParsed.format("YYYY-MM-DD") : null,
      };

      infos.emploi = {
        identreprise: this.entrepriseSelect.identreprise,
        idposte: this.poste.idformation_emploi_poste,
        idcontrat: this.contrat.idformation_emploi_contrat,
        idstatut: this.statut.idformation_emploi_status,
        date_start: startContractParsed.format("YYYY-MM-DD"),
      }

      try {
        let res = await axios.post("/api/afpf/creation-salarie", infos);
        this.launchToast("Collaborateur créé avec succès");
        this.$emit("created", res.data);
        this.$emit("input", false);
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors de la création du collaborateur");
      }
    },
    closeModal() {
      this.$emit("input", false);
    },
    launchToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    async getListEntreprises() {
      try {
        console.log("getListEntreprises");
        let res = await axios.get("/api/retours/liste-entreprises");

        this.listeEntreprise = res.data.listeEntreprise;
        this.isready = true;

      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement");
      }
    },
  },
  mounted() {
    this.showSalarie = this.value;
  },
  watch: {
    isready() {
      if (this.isready) {
        console.log("identreprise", this.identreprise);
        if (this.identreprise) {
          let index = this.listeEntreprise.findIndex(p => p.identreprise == this.identreprise);
          if (index > -1) {
            this.entrepriseSelect = this.listeEntreprise[index];
          }
        }
      }
    },
    value() {
      // Parent property changed; update internal variables
      this.showSalarie = this.value;
      //  this.resetValues();
      if (this.value) {
        this.isready = false;
        this.getListEntreprises();
      }
    }
  },
  computed: {
  }

}
  </script>
  
  <style lang="scss">
.padded-input {
  padding-left: 0.25rem;
}
.specialwidth {
  width: 45vw;
  height: 40vh;
  overflow: auto;
}
</style>
